import React from "react";
import { isNull } from "lodash";

const ReviewSummary = (props) => {
  const {
    values,
    employeePlans,
    selectedPlan,
    vestedBalance,
    grossSum,
    getWithdrawalName,
    sourceSplit,
  } = props;

  return (
    <div className="request-Summary">
      <p className="fw-500 ft-14 Grey-Color px-20-20">Review summary</p>
      <div className="d-flex flex-col p-20 Border-Top ">
        <p className="fw-400 ft-12 Grey-Color m-0">Plan Name</p>
        <p className="fw-600 ft-14 black-text m-0 ">
          {employeePlans && employeePlans[selectedPlan]?.planName}
        </p>
      </div>

      <div className="d-flex flex-col p-20 Border-Top ">
        <p className="fw-400 ft-12 Grey-Color m-0">Vested balance</p>
        <p className="fw-600 ft-14 black-text m-0">$ {vestedBalance}</p>
      </div>
      <div className="d-flex flex-col p-20 Border-Top ">
        <p className="fw-400 ft-12 Grey-Color m-0">Withdrawal type</p>
        <p className="fw-600 ft-14 black-text m-0">{values?.withdrawalName}</p>
      </div>
      <div className="d-flex flex-col p-20 Border-Top ">
        <p className="fw-400 ft-12 Grey-Color m-0">Distribution Mode</p>
        {values.distribution?.map((data, ind) => (
          <div className=" d-flex flex-row space-between">
            {data.distributionMode == 1 && (
              <p className="ft-14 fw-500 Dark-Grey-Color">Cash Distribution</p>
            )}
            {data.distributionMode == 2 && (
              <p className="ft-14 fw-500 Dark-Grey-Color">Traditional IRA</p>
            )}
            {data.distributionMode == 3 && (
              <p className="ft-14 fw-500 Dark-Grey-Color">Roth IRA</p>
            )}
            {data.distributionMode == 4 && (
              <p className="ft-14 fw-500 Dark-Grey-Color">Employer Sponsored</p>
            )}

            {!isNull(data.distributionMode) && (
              <p className="ft-14 fw-600 Dark-Grey-Color">
                ${" "}
                {sourceSplit[ind]?.grossWithdrawalAmount
                  ? sourceSplit[ind]?.grossWithdrawalAmount?.toFixed(2)
                  : values.withdrawEntire
                  ? (vestedBalance - grossSum)?.toFixed(2)
                  : 0}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewSummary;
